// Wrap the whole app in the cookie-consent provider (banner + gated trackers).
// Shared with gatsby-ssr.js.
export { wrapRootElement } from "./gatsby-shared"

export const onRouteUpdate = ({ location }) => {
  if (!location.hash) {
    window.scrollTo(0, 0);
  }

  // GTM is injected client-side by <TrackerScripts>, so SPA route changes must
  // be pushed manually. Fire for all visitors: GA4 honors Consent Mode
  // (cookieless while denied), so route changes are counted (modeled) even
  // without consent. dataLayer always exists (seeded by the Consent Mode default
  // snippet in <head>).
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "gatsby-route-change" });
  }
};
